const TRANSLATION = {
  buyModal: {
    afterFree: 'Efter din kostnadsfria provperiod',
    btn: 'Prova kostnadsfritt',
    freeTrial: '3-dagars kostnadsfri provperiod',
    monthLabel: 'månad',
    selectLabel: 'Välj ett plan',
    title: 'Prenumerationsplan',
    yearLabel: 'år',
  },
  contact: {
    block1:
      'För anpassning, frågor eller förslag, vänligen kontakta oss på contact@noam.tools. Vi svarar snabbt.',
    block2: 'Stöd oss genom att betygsätta oss på Google Apps Extension-butiken med ★★★★★.',
    block3: 'Hjälp andra genom att dela denna tillägg: ',
    title: 'Kontakta oss',
  },
  help: {
    AquickOverviewOfNoam: 'En snabb översikt av Noam',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Hantering av favoriter',
    Fixedplugin: 'Rättad plugin',
    Focusing: 'Fokuserar',
    Free: 'Gratis',
    FreeTrialBenefits: 'Förmåner med kostnadsfri provperiod',
    GoWithWikipedia: 'Gå med Wikipedia',
    GoWithYouTube: 'Gå med YouTube',
    HoverTranslation: 'Hoveröversättning',
    Howtouse: 'Hur man använder',
    ImageTranslation: 'Bildöversättning',
    InstantTranslation: 'Omedelbar översättning',
    Membership: 'Medlemskap',
    NoamHelp: 'Noam hjälper dig att översätta och sammanfatta',
    PDFparallelTranslation: 'PDF-parallellöversättning',
    ParallelTranslation: 'Parallell översättning',
    SkipAllSteps: 'Hoppa över alla steg',
    Summary: 'Sammanfattning',
    Translation: 'Översättning',
    TryItForFree: 'Prova det kostnadsfritt',
    Video: 'Video',
    VideoSummary: 'Videorsammanfattning',
    VideoTranslation: 'Videöversättning',
    WebSummary: 'Webböversikt',
    WordSelectionTranslation: 'Ordsammanställningsöversättning',
    benefits: 'Vi har förmåner som väntar på dig!',
    dayFree: '3-dagars kostnadsfri provperiod',
    done: 'Klar',
    next: 'Nästa',
    pin: 'Fäst Noam för lättare åtkomst～～',
    planIsNotExist: 'Planen är inte tillgänglig',
    startWiki: 'Låt oss börja med Wikimedia!',
    startYoutube: 'Låt oss börja med YouTube!',
    try: 'Prova det',
    tryNow: 'Prova det nu!',
  },
  home: {
    PDFTranslate: {
      desc: 'Dubbelspråkig översättning + Chat PDF',
      sub1: {
        desc: 'Tvåspråkig läsning låter dig jämföra originaltexten och översättningen sida vid sida, vilket förbättrar läseeffektiviteten.',
        title: 'Tvåspråkig läsning',
      },
      sub2: {
        desc: 'AI analyserar och sammanfattar, och kan svara på dina frågor baserat på PDF-innehållet.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'AI-drivna PDF-översättningar för högre noggrannhet och effektivitet.',
        title: 'Precision och effektivitet',
      },
      title: 'PDF Översätt',
    },
    aiAssistant: {
      desc: 'Gör webböversättning smartare och mer bekväm',
      panel1: {
        desc: 'Dubbelspråkiga översättningar med ömsesidig hänvisning hjälper dig att jämföra originaltexten med översättningen, vilket gör att du förstår bättre och förbättrar din läseeffektivitet.',
        title: 'Tvåspråkig översättning',
      },
      panel2: {
        left: {
          desc: 'När du bläddrar på en webbsida, hovra över det innehåll du behöver översätta för att se översättningen.',
          title: 'Hoveröversättning',
        },
        right: {
          desc: 'När du bläddrar på en webbsida, välj den text du vill översätta för att se översättningen.',
          title: 'Texturvalsoversättning',
        },
      },
      panel3: {
        one: {
          desc: 'Översätt och sammanfatta webbsidor och videor var och när du vill för en jämnare upplevelse!',
          title: 'Klicka och pek',
        },
        three: {
          desc: 'AI-driven stor språkmodell säkerställer översättningsnoggrannhet och konsistens för en förbättrad läsupplevelse.',
          title: 'AI-driven',
        },
        two: {
          desc: 'Flerspråkig full täckning, tvåspråkig barriärfri läsning, översättning med ett klick – upplev skillnaden!',
          title: 'Mer omfattande och bekväm',
        },
      },
      panel4: {
        tab1: {
          desc: 'Din effektivitetsexpert – med hjälp av ChatGPT översätter och sammanfattar Noam YouTube-videor för att spara dig tid!',
          key: 'Video',
          title: 'Videöversättning & Sammanfattning',
        },
        tab2: {
          desc: 'Klicka för att översätta bilder när du surfar på webben.',
          key: 'Bild',
          title: 'Bildöversättning',
        },
        tab3: {
          desc: 'Extraherar omedelbart nyckelinformation från webbsidor och ger en sammanfattning, vilket ökar din läseeffektivitet.',
          key: 'Webb',
          title: 'Weböversättning & Sammanfattning',
        },
        tag1: 'Enkel',
        tag2: 'Effektiv',
        tag3: 'Lätt att förstå',
      },
      title: 'AI-assistent',
    },
    getStart: 'Börja',
    getStartedForFree: 'Börja kostnadsfritt',
    howItWork: {
      desc: 'Noam integrerar AI-modeller för att erbjuda användare en intelligent upplevelse för tvärspråklig webbsidöversättning och sammanfattning, PDF- och bildöversättning samt videoöversättning och sammanfattning',
      title: 'Hur det fungerar',
    },
    lastBlock: { desc: 'Bättre AI-översättning för en jämnare läsupplevelse' },
    top: {
      desc: 'Noam är ett kostnadsfritt AI-webbläsartillägg som hjälper dig att översätta och sammanfatta webbsidor, videor och PDF-innehåll.\n      Bli medlem i Noam och upplev magin!',
      title1: 'Ett Magi',
      title2: 'Ett klick',
    },
    userReviews: {
      desc: 'Femstjärniga recensioner på Chrome Web Store',
      title: 'Användarrecensioner',
    },
  },
  installTips: {
    btn: 'Prova nu',
    text: 'Installera "Noam Browser Plugin" för att låsa upp fler funktioner! Webbkorsreferens,\n    sammanfattning av webbvideor och mycket mer!',
  },
  locale: {
    af: 'afrikaans',
    am: 'amhariska',
    ar: 'arabiska',
    as: 'assamesiska',
    auto: 'Automatisk detektering',
    az: 'azerbajdzjanska',
    ba: 'basjkir',
    bg: 'bulgarisk',
    bn: 'bengali',
    bo: 'tibetanska',
    bs: 'bosniska',
    ca: 'katalanska',
    cs: 'tjeckisk',
    cy: 'walesiska',
    da: 'dansk',
    de: 'tyska',
    dsb: 'nedersorbiska',
    dv: 'divehi',
    el: 'grekisk',
    en: 'Engelska',
    es: 'spanska',
    et: 'estniska',
    eu: 'baskiska',
    fa: 'persisk',
    fi: 'finska',
    fil: 'filipino',
    fj: 'fijianska',
    fr: 'franska',
    frCA: 'franska (Kanada)',
    ga: 'irländsk',
    gl: 'galiciska',
    gom: 'Konkani',
    gu: 'gujarati',
    ha: 'hausa',
    he: 'hebreiska',
    hi: 'hindi',
    hr: 'kroatisk',
    hsb: 'övre sorbiska',
    ht: 'haitiansk kreol',
    hu: 'ungerska',
    hy: 'armenska',
    id: 'indonesiska',
    ig: 'igbo',
    ikt: 'Inuinnaqtun',
    is: 'isländska',
    it: 'italien',
    iu: 'inuktitut',
    iuLatn: 'inuktitut (latin)',
    ja: 'japanska',
    ka: 'georgisk',
    kk: 'kazakh',
    km: 'khmer',
    kmr: 'Kurdiska (norra)',
    kn: 'kannada',
    ko: 'koreanska',
    ku: 'Kurdiska (central)',
    ky: 'kyrgyz',
    ln: 'Lingala',
    lo: 'Lao',
    lt: 'litauisk',
    lug: 'ganda',
    lv: 'latviska',
    lzh: 'kinesiska (litterärt)',
    mai: 'Maithili',
    mg: 'malagassiska',
    mi: 'maori',
    mk: 'makedonska',
    ml: 'malayalam',
    mnCyrl: 'mongoliska (kyrilliska)',
    mnMong: 'mongoliska (traditionell)',
    mr: 'marathi',
    ms: 'malajiska',
    mt: 'maltesiska',
    mww: 'Hmong Daw',
    my: 'Myanmar (burmesisk)',
    nb: 'norska',
    ne: 'nepalesiska',
    nl: 'nederländska',
    noSearchLang: 'Språk stöds inte',
    nso: 'Sesotho sa Leboa',
    nya: 'nyanja',
    or: 'Odia',
    otq: 'Querétaro Otomi',
    pa: 'punjabi',
    pl: 'polska',
    placeholder: 'Sök',
    prs: 'Dari',
    ps: 'pashto',
    pt: 'Portugisiska (Brasilien)',
    ptPT: 'Portugisiska (Portugal)',
    ro: 'rumänska',
    ru: 'ryska',
    run: 'Rundi',
    rw: 'kinyarwanda',
    sd: 'sindhi',
    si: 'singalesiska',
    sk: 'slovakiska',
    sl: 'slovenska',
    sm: 'samoisisk',
    sn: 'Shona',
    so: 'somalier',
    sq: 'albanska',
    srCyrl: 'serbiska (kyrilliska)',
    srLatn: 'Serbiska (latin)',
    st: 'sesotho',
    sv: 'Svenska',
    sw: 'swahili',
    ta: 'tamil',
    te: 'telugu',
    th: 'thailändska',
    ti: 'tigrinya',
    tk: 'turkmener',
    tlhLatn: 'Klingon',
    tlhPiqd: 'Klingon (pIqaD)',
    tn: 'Setswana',
    to: 'tongansk',
    tr: 'turkiska',
    tt: 'tatare',
    ty: 'tahitisk',
    ug: 'uyghur',
    uk: 'ukrainska',
    ur: 'urdu',
    uz: 'Uzbekiska (latin)',
    vi: 'vietnamesiska',
    xh: 'xhosa',
    yo: 'joruba',
    yua: 'yucatekiska maya',
    yue: 'kantonesiska (traditionell)',
    zh: 'kinesiska',
    zhHans: 'Kinesiska förenklad',
    zhHant: 'Traditionell kinesiska',
    zu: 'zulu',
  },
  login: {
    and: 'och',
    btn: 'Logga in med Google',
    btn1: 'Logga in nu',
    desc: 'Logga in för att låsa upp fler upplevelser',
    policy: 'Integritetspolicy',
    terms: 'Användningsvillkor',
    tips: 'Genom att registrera mig godkänner jag',
    title: 'Välkommen till Noam',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Följ', twitter: 'Twitter' },
    legal: { policy: 'Integritetspolicy', terms: 'Användarvillkor', title: 'Juridisk' },
    product: {
      image: 'Bildöversättning',
      pdf: 'PDF-översättning',
      title: 'Produkter',
      video: 'Videöversättning & Sammanfattning',
      web: 'Webböversättning och sammanfattning',
    },
    resources: { title: 'Resurser' },
    tools: { title: 'Verktyg', pdf: 'PDF-översättning' },
  },
  pageHeader: {
    contact: 'Kontakt',
    help: 'Hjälp',
    logout: 'Logga ut',
    logoutSucc: 'Utloggad.',
    pricing: 'Priser',
    settings: 'Inställningar',
    signUp: 'Logga in',
  },
  pdf: {
    autoDetect: 'Automatisk upptäckt',
    cancelBtn: 'Avbryt',
    cancelUpload: 'Avbryt',
    chatPdf: {
      summaryError: 'Sammanfattning misslyckades, försök igen senare',
      chatError: 'Chatten misslyckades, försök igen senare',
      Search: 'Sök',
      cancel: 'Avbryt',
      chatTitle: 'Välkommen till Noam! Här är en sammanfattning av din PDF:',
      clear: 'Rensad',
      clearContent:
        'Detta kommer att starta en ny konversation. Den aktuella konversationen kommer inte att sparas. Är du säker?',
      clearDialogTitle: 'Bekräfta',
      clearSucc: 'Rensad',
      copy: 'Kopiera',
      copySucc: 'Kopierat',
      delete: 'Radera',
      deleteCancel: 'Avbryt',
      deleteContent: 'Denna PDF kan inte återställas efter att den har tagits bort. Är du säker?',
      deleteOk: 'Radera',
      deleteSuccess: 'Raderad',
      deleteTitle: 'Bekräfta radering',
      expand: 'Kollaps',
      historyTitle: 'Historia',
      listError:
        'Misslyckades med att läsa in läslistan. Försök igen senare eller kontakta supporten.',
      loading: 'Laddar...',
      noDataDesc: 'Ingen historia ännu.',
      noMore: 'Inget mer innehåll.',
      placeholder: 'Fråga om vad som helst om denna PDF',
      summaryTitle: 'Du kanske är intresserad av dessa frågor:',
    },
    collectionEmpty: 'Din samling är tom.',
    collectionTab: 'Anteckningar',
    dataLoading: 'Laddar...',
    dialogContent: 'Är du säker på att du vill radera detta?',
    dialogTitle: 'Bekräfta',
    download: {
      both: 'tvåspråkig',
      btn: 'Spara',
      cancel:
        'Att stänga det här fönstret avbryter PDF-laddningen. Är du säker på att du vill avbryta?',
      desc: 'Spara till enhet: Laddar ner översättningar som bilder; Spara & skriv ut: Laddar ner översättningar i originalformat med kopieringsstöd.',
      download: 'Ladda ner',
      downloadMsg1: 'PDF-översättningens förlopp:',
      downloadMsg2: 'Beräknad återstående tid:',
      downloadSucc: 'PDF är klar! Klicka för att spara.',
      downloadTip: 'Laddar ner PDF. Stäng inte detta fönster för att undvika nedladdningsfel.',
      error: 'Misslyckades att spara. Prova att skriva ut istället.',
      fileName: 'Filnamn:',
      fileType: 'Filtyp:',
      loading: 'Sparar...',
      loading2: 'Laddar...',
      minute: 'Minuter...',
      msg1: 'Vissa översättningar i denna dokument är längre än originaltexten och kan överlappa i den nedladdade filen. Vi rekommenderar att du läser på webbsidan.',
      msg2: 'Översättningen är inte ännu klar. Ladda ner efter att översättningen är färdig.',
      msg3: '2. Vissa översättningar är för långa. Läs på webbsidan för att undvika textöverlapp.',
      msg4: 'Översättningsuppgifter pågår. Var god försök igen när de är färdiga.',
      progress:
        'Översätter PDF. Förlopp: {{progress}}, Beräknad återstående tid: {{minutes}} minuter...',
      save: 'Spara till enhet',
      savePrint: 'Spara & Skriv ut',
      success: 'Nerladdad',
      trans: 'Endast översättning',
      transContinue: 'Fortsätt översätta',
    },
    downloadBtn: 'Ladda ner',
    dragTipModal: {
      black: 'rymden',
      leftKey: 'vänsterknapp',
      ok: 'Jag förstår',
      press: 'Press',
      tips: 'att dra och visa',
    },
    entry: 'PDF-filer',
    fileErrMsg: 'Filinläsning misslyckades. Försök igen senare eller kontakta supporten.',
    fileMsg: 'Aktuell filstorlek:',
    fileMsg2: 'Ladda upp en fil som är mindre än 300MB.',
    freeBannerBtn: 'Uppgradera',
    freeBannerTips: 'Gränsen för kostnadsfria PDF-översättningar har nåtts',
    guide: {
      placeholder: 'Klistra in PDF-länken här',
      start: 'Börja översätta',
      text1: 'Tvåspråkig läsning',
      text2:
        'Läs tvåspråkigt för att jämföra originaltexten och översättningen sida vid sida, vilket ökar din effektivitet.',
      text3: 'Chatta med din PDF',
      text4: 'AI-driven analys och sammanfattning. Ställ frågor om din PDF och få omedelbara svar.',
      text5: 'Precis och effektiv',
      text6: 'AI-driven PDF-översättning för högre noggrannhet och effektivitet.',
      title1: 'Tvåspråkig översättning',
      title2: 'Chatta med din PDF',
      toast: 'Ange en giltig online-PDF-länk som slutar med .pdf',
    },
    hasTransTask: 'En översättning pågår. Vänta lite.',
    hoverTrans: 'Paragrafer med hovringsöversättning',
    initial: 'Översätt PDF',
    installText: 'Din allt-i-ett-lösning för vardagliga översättningar.',
    installText2: 'Installera först tillägget',
    installTips:
      'Installera tillägget för ännu fler PDF-översättningar och jämnare webbplatsöversättningar:',
    kw: 'stift',
    link: 'länk',
    listError: 'Kunde inte läsa in PDF-filer. Försök igen senare eller kontakta supporten.',
    memoTotalCount: '1 produkt totalt',
    new: 'ny fil',
    noId: 'Fil-ID hittades inte.',
    notPdf: 'Endast PDF-filer.',
    okBtn: 'Radera',
    okBtn2: 'Jag förstår',
    original:
      'Du är en mycket precis och pålitlig AI designad för att generera JSON-utdata som exakt överensstämmer med ett specificerat JSON-schema.\n\nDu måste följa dessa regler:\n1. Strikt följ JSON-schematstrukturen.\n2. Matcha alla datatyper, obligatoriska fält och begränsningar exakt.\n3. INTE inkludera någon extra text, förklaring, markdown eller kommentarer.\n4. Skriv UTENFÖR endast JSON-objektet — inga kodblock, ingen förtext, ingen omslutning.\n\nSchemainformationen finns nedan.\n- Schema Namn: translate_result\n- JSON Schema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Parallell',
    parseErrDialogContent:
      'Denna PDF-länk kan inte översättas direkt. Ladda ner PDF-filen och ladda upp den för översättning.',
    parseErrTips: 'Misslyckades med att tolka filen',
    parseFileToast:
      'Misslyckades med att tolka filen. Försök igen senare eller kontakta supporten.',
    pdfLoading: 'Parsar...',
    searchPlaceholder: 'Sök',
    selectTrans: 'Välj text att översätta',
    shareBtn: 'Dela',
    shareBtnText1: 'Generera delningslänk',
    shareBtnText2: 'Uppdatera delat innehåll',
    shareModal: {
      cancel: 'Avbryt',
      copy: 'Kopiera',
      copySucc: 'Länk kopierad',
      custom: 'Anpassa:',
      errMsg:
        'Det valda innehållet har inte blivit helt översatt ännu. Var vänlig översätt innan du delar.',
      gen: 'Dela',
      modify: 'Redigera',
      notSupport: 'Denna språk stöds för närvarande inte.',
      page: 'Sidor',
      pageNuErr: 'Ange ett giltigt sidnummer.',
      range: 'Omfång:',
      remain: 'återstående',
      remain1: 'Beräknad total tid:',
      search: 'Sök',
      settings: 'Delningsinställningar:',
      shareSetting: 'Delningsinställningar',
      shareText: 'Dela',
      shareTips: 'Dela länken till den översatta PDF-filen med dina vänner:',
      sourceLang: 'Från:',
      target: 'Till:',
      text1: 'Delningsinställningar',
      text2: 'Generera delningslänk',
      totalPage: 'Totalt 1 sida',
      trans: 'Översätt',
      translateTips:
        'Tips: Om översättningen tar tid kan du stänga det här fönstret och dela senare.',
      translating: 'Översätter PDF...',
      update: 'Uppdatera delningslänk',
    },
    shareMsg1: 'Delningslänk genererad.',
    shareMsg2: 'Delat innehåll uppdaterat.',
    shareMsg3:
      'Misslyckades med att generera delningslänk. Försök igen senare eller kontakta supporten.',
    shareMsg4:
      'Misslyckades med att uppdatera delat innehåll. Försök igen senare eller kontakta supporten.',
    shareTips: 'Din PDF-översättning är klar! Dela den med dina vänner.',
    start: 'Börja din kostnadsfria provperiod',
    thumbnail: 'Innehållsförteckning',
    toast1: 'Laddar PDF. Försök igen senare.',
    toast2: 'PDF-innehåll behandlas. Dialog stöds för närvarande inte.',
    toast3: 'Laddar ner. Var god försök igen när nedladdningen är klar.',
    toolbar: { Adjust: 'Justera', autoFit: 'Autoanpassa' },
    trans: 'Översättning',
    transSucc: 'Översättning lyckades!',
    unLoginToast: 'Vänligen logga in för att använda den här funktionen.',
    uploadBtn: 'Ladda upp',
    uploadErr: 'Filuppladdningen misslyckades. Försök igen senare eller kontakta supporten.',
    uploadErrSignUrl:
      'Misslyckades med att hämta uppladdnings-URL. Försök igen senare eller kontakta supporten.',
    uploadMsg1: 'Dra och släpp din fil här.',
    uploadMsg2: 'Stödjande filtyper: PDF  |  Maximal filstorlek: 300MB',
    uploadMsg3: 'Klicka för att välja eller dra och släpp filer här.',
    uploading: 'Laddar upp',
    uploadingMsg: 'Laddar upp. Vänta lite.',
    uploadingMsg1: 'Fil uppladdas. Var god försök igen senare.',
    uploadingMsg2: 'En fil konverteras för närvarande. Var god försök igen senare.',
    uploadingMsg3:
      'Begäran om konverteringsförlopp misslyckades. Försök igen senare eller kontakta supporten.',
    uploadingMsg4:
      'Noam kan inte komma åt lokala filer. Ladda upp en PDF manuellt för översättning.',
    uploadingMsg5:
      'Misslyckades med att hämta filens URL. Försök igen senare eller kontakta supporten.',
    video: 'video',
    vipBannerBtn: 'Uppgradera',
    vipBannerTips: 'Du har nått din månatliga gräns för PDF-översättningar.',
    webTrans: 'Fullständig korsreferens',
  },
  pricing: {
    FAQ: 'FAQ',
    FQAObj: {
      a1: 'Ja, Noam erbjuder en kostnadsfri plan som du kan använda direkt.',
      a2: 'Vi erbjuder tre medlemsplaner: Pro, Pro+ och Enterprise. Du kan välja att betala månatligen eller årligt. Årligen fakturering erbjuder betydande besparingar.',
      a3: 'Alla funktioner är tillgängliga på båda planerna. Huvudskillnaden är kostnaden: årliga prenumerationer kostar mindre totalt. Månatliga prenumerationer faktureras varje månad, medan årliga planer faktureras en gång per år.',
      a4: 'Du kan avbryta din prenumeration när som helst i dina kontoinställningar.',
      q1: 'Finns det en kostnadsfri plan?',
      q2: 'Vilka priser och betalningsalternativ finns det?',
      q3: 'Vad är skillnaden mellan månatlig och årlig prenumeration?',
      q4: 'Hur avbryter jag min prenumeration?',
    },
    around: 'Runt',
    billedMonthly: 'Faktureras månatligen',
    billedYearly: 'Faktureras årligen',
    day: 'dag',
    desc: 'Jämför planer och välj den bästa',
    detailedCompare: 'Jämför planer',
    discount: '20% rabatt',
    enterprise: {
      benefit1: 'Prioriterad kundsupport',
      benefit2: 'Flera användare',
      benefit3: 'Anpassade Lösningar',
      benefit5: 'Dedikerad kontoansvarig',
      btn: 'Kontakta oss',
      recommendText: 'Anpassade planer (≥3 personer)',
      talkToUs: 'Kontakta oss',
    },
    free: {
      benefit1: 'Omedelbar översättning 100 gånger/dag',
      benefit2: 'Webbplatsöversättning och sammanfattning',
      benefit3: '30 bildöversättningar',
      benefit4: 'Videöversättning & Sammanfattning',
      benefit5: '10 PDF-översättningar',
      benefit6: '5 000 tokens',
      btn: 'Prova kostnadsfritt',
      recommendText: 'Gratis provperiod',
    },
    imageTranslation: 'Bildöversättning',
    month: 'månad',
    monthly: 'Månatlig',
    pageTitle: 'Priser',
    pdf: {
      chat: 'PDF-chattförfrågningar',
      maxPage: 'Max. sidor per PDF',
      translation: 'PDF-översättning',
    },
    preMonth: 'Per månad',
    pro: {
      benefit1: 'Prioriterad kundsupport',
      benefit2: '1 000 000 token/månad',
      benefit3: 'Webbplatsöversättning & Sammanfattning',
      benefit4: '200 bildöversättningar',
      benefit5: 'Videöversättning & Sammanfattning',
      benefit6: '200 PDF-översättningar',
      btn: 'Kom igång',
      recommendText: 'Mest populärt',
    },
    proPlus: {
      benefit1: 'Prioriterad kundsupport',
      benefit2: '3 000 000 token/månad',
      benefit3: 'Webbplatsöversättning & Sammanfattning',
      benefit4: '500 bildöversättningar',
      benefit5: 'Videöversättning och sammanfattning',
      benefit6: '500 PDF-översättningar',
      recommendText: 'Bästa värdet',
    },
    video: { summary: 'Videorsammanfattning', translation: 'Videöversättning' },
    web: {
      contrastiveTranslation: 'Tvåspråkig översättning',
      dictionaryTranslation: 'Urval Översättning',
      hoverTranslation: 'Hover-översättning',
      instantTranslation: 'Omedelbar översättning',
      summary: 'Webbsidorsammanfattning',
    },
    yearly: 'Årligt',
  },
  privacy: {
    block1:
      'Noam ("Noam", "vi", "vår" eller "oss") respekterar din integritet och strävar efter att skydda all information vi erhåller från dig eller om dig. Denna sekretesspolicy beskriver våra praxis gällande insamling och användning av personlig information från din användning av vår webbplats, applikationer och tjänster (sammantaget kallade "Tjänster"). Denna sekretesspolicy gäller inte för innehåll som vi hanterar på behalf av våra affärsproduktkunder, såsom vår API. Användning av denna data regleras av vårt kundavtal, vilket täcker åtkomst till och användning av dessa produkter.',
    block10:
      'Vi implementerar kommersiellt rimliga tekniska, administrativa och organisatoriska åtgärder för att skydda personlig information online och offline mot förlust, missbruk och obehörig åtkomst, avslöjande, förändring eller illvilliga handlingar. Emellertid kan ingen internet- eller e-postöverföring garantera fullständig säkerhet eller noggrannhet. I synnerhet kan e-postmeddelanden som skickas till oss eller från oss inte vara säkra. Därför bör du vara särskilt försiktig när du bestämmer vilken information du skickar till oss via tjänsten eller e-post. Dessutom ansvarar vi inte för några hinder för sekretessinställningar eller säkerhetsåtgärder i tjänsten eller på tredje parts webbplatser. Vi kommer att bevara din personliga information så länge det behövs för att vi ska kunna erbjuda dig tjänster eller för andra legitima affärsmål, såsom att lösa tvister, säkerhets- och säkerhetsorsaker eller efterleva våra juridiska skyldigheter. Tiden vi behåller personlig information kommer att bero på många faktorer, såsom mängden, karaktären, känsligheten av informationen, de potentiella riskerna med obehörig användning eller avslöjande, de syften för vilka vi behandlar informationen och andra juridiskt bindande överväganden.',
    block11:
      'Vi kan uppdatera denna sekretesspolicy från tid till annan. När vi gör det kommer vi att publicera en uppdaterad version på denna sida, om inte tillämplig lag föreskriver något annat.',
    block12:
      'Om du har några obesvarade frågor eller bekymmer angående denna sekretesspolicy, vänligen kontakta vår kundtjänst. E-post:',
    block2: 'Vi samlar in följande personuppgifter ("Personuppgifter") som rör dig:',
    block3:
      'Information som du tillhandahåller: När du skapar ett konto för att använda våra tjänster eller kommunicera med oss samlar vi in personlig information enligt följande:',
    block4:
      'Personlig information som automatiskt erhålls från din användning av tjänsterna: När du kommer åt, använder eller interagerar med tjänsterna, får vi följande information om din åtkomst, användning eller interaktion ("Teknisk information"):',
    block5: 'Vi kan använda personlig information för följande ändamål:',
    block6:
      'Sammanställning eller anonymiserad information: Vi kan sammanställa eller anonymisera personlig information för att förhindra att den används igen för identifieringsändamål och använda denna information för att analysera effektiviteten i våra tjänster, förbättra och lägga till funktioner i våra tjänster, utföra forskning och för liknande ändamål. Dessutom kan vi analysera den allmänna beteendet och egenskaperna hos våra tjänstebrukare och dela sammanställd information med tredje part, publicera sådan sammanställd information eller göra den allmänt tillgänglig. Vi kan samla in sammanställd information genom tjänsterna, via cookies och genom andra medel som beskrivs i denna sekretesspolicy. Vi kommer att underhålla och använda anonymiserad information i anonym eller anonymiserad form, och vi kommer inte att försöka re-identifiera denna information om inte lagkräver det.',
    block7:
      'I vissa fall kan vi lämna ut dina personuppgifter till tredje part utan ytterligare meddelande till dig, om inte lagstiftningen kräver det:',
    block8:
      'Beroende på din geografiska plats kan personer inom Europeiska ekonomiska området, Storbritannien och globalt ha vissa lagstadgade rättigheter gällande deras personuppgifter. Du kan till exempel ha rätt att:',
    block9:
      'Tjänsten kan innehålla länkar till andra webbplatser som inte drivs eller kontrolleras av Noam, inklusive sociala medietjänster ("Tredjepart-webbplatser"). Informationen du delar med tredjepart-webbplatser regleras av de specifika sekretesspolicyerna och användarvillkoren för tredjepart-webbplatserna, inte av denna sekretesspolicy. Vi tillhandahåller dessa länkar för bekvämlighet och implicerar inte att vi stödjer eller har granskat dessa webbplatser. Kontakta direkt tredjepart-webbplatserna för information om deras sekretesspolicyer och villkor.',
    subBlock1:
      'Kontoinformation: När du skapar ett konto på vår plattform samlar vi in information relaterad till ditt konto, inklusive ditt namn, kontaktuppgifter, kontouppgifter, kreditkortsinformation och transaktionshistorik ("Kontoinformation").',
    subBlock10: 'Att tillhandahålla, hantera, underhålla och/eller analysera tjänster;',
    subBlock11: 'Att kommunicera med dig;',
    subBlock12: 'Utveckla nya produkter och tjänster;',
    subBlock13:
      'Att förebygga bedrägerier, brottslig aktivitet eller missbruk av våra tjänster, samt skydda säkerheten för våra IT-system, arkitektur och nätverk;',
    subBlock14: 'Utförande av företagsöverföringar;',
    subBlock15:
      'Att följa juridiska skyldigheter och rättsförfaranden, skydda våra rättigheter, integritet, säkerhet eller egendom, samt sådana för våra dotterbolag, dig eller andra tredje parter.',
    subBlock16:
      'Leverantörer och tjänsteleverantörer: För att hjälpa oss att uppfylla affärsoperativa behov och utföra vissa tjänster och funktioner kan vi lämna ut personlig information till leverantörer och tjänsteleverantörer, inklusive värdtjänsteleverantörer, molntjänsteleverantörer och andra informations- och kommunikationstekniktjänsteleverantörer, e-postkommunikationsprogramvara och webbanalystjänsteleverantörer med mera. Dessa partners kommer endast att komma åt, bearbeta eller lagra personlig information enligt våra instruktioner när de utför sina uppgifter för oss.',
    subBlock17:
      'Affärsoverföringar: Om vi genomför strategiska transaktioner, omorganisationer, konkurser, konkursuppköp eller överföring av tjänster till en annan leverantör (sammansättningsvis "Transaktioner"), kan din personliga information och annan information delas med transaktionsmotparter och andra parter som协助 med Transaktionerna under due diligence samt överföras som en del av Transaktionerna tillsammans med andra tillgångar till ett efterföljande eller affilierat företag.',
    subBlock18:
      'Lagkrav: Vi kan dela din personliga information med myndigheter, branschkollegor eller andra tredje parter, inklusive din interaktionsinformation med våra tjänster, (1) om det krävs enligt lag eller om vi anser att en sådan åtgärd är nödvändig för att uppfylla juridiska skyldigheter; (2) för att skydda och försvara våra rättigheter eller egendom; (3) om vi ensidigt fastställer att det finns en överträdelse av våra villkor, policyer eller lagar; (4) för att upptäcka eller förebygga bedrägeri eller andra illegala aktiviteter; (5) för att skydda våra produkter, anställda eller användare, eller allmän säkerhet, trygghet, integritet; eller (vi) för att försvara oss mot juridisk ansvarighet.',
    subBlock19: 'Få tillgång till din personliga information och information om hur den behandlas.',
    subBlock2:
      'När du använder våra tjänster samlar vi in personlig information från dina inmatningar, filuppladdningar eller feedback som du tillhandahåller till oss ("Innehåll").',
    subBlock20: 'Begär radering av dina personuppgifter från våra register.',
    subBlock21: 'Korrigera eller uppdatera dina personuppgifter.',
    subBlock22: 'Överför dina personuppgifter till en tredje part (dataportabilitet).',
    subBlock23: 'Begränsa hur vi behandlar dina personuppgifter.',
    subBlock24:
      'Dra tillbaka ditt samtycke – när vi förlitar oss på samtycke som rättslig grund för behandling kan du dra tillbaka ditt samtycke när som helst.',
    subBlock25: 'Protestera mot hur vi behandlar dina personuppgifter.',
    subBlock26: 'Förbättra våra tjänster och genomföra forskning;',
    subBlock3:
      'Kommunikationsinformation: Om du skickar oss meddelanden kommer vi att samla in ditt namn, kontaktuppgifter och innehållet i dina meddelanden ("Kommunikationsinformation").',
    subBlock4:
      'Information om sociala medier: Vi har sidor på sociala medieplattformar som Instagram, Facebook, Medium, Twitter, YouTube och LinkedIn. När du interagerar med våra sociala mediesidor samlar vi in den personliga information du väljer att tillhandahålla oss, såsom dina kontaktuppgifter ("Social information"). Dessutom kan de företag som är värdar för våra sociala mediesidor tillhandahålla oss aggregerad information och analys om våra sociala medieaktiviteter.',
    subBlock5:
      'Loggdata: Information som automatiskt skickas av din webbläsare när du använder våra tjänster. Loggdata inkluderar din Internet Protocol (IP)-adress, webbläsartyp och inställningar, datum och tid för dina förfrågningar samt hur du interagerar med vår webbplats.',
    subBlock6:
      'Användningsdata: Vi kan automatiskt samla in information om din användning av tjänsten, såsom typerna av innehåll du visar eller interagerar med, de funktioner du använder, de åtgärder du tar, samt din tidszon, land, åtkomstdatum och -tid, användaragent och version, typ av dator eller mobil enhet samt din datoranslutning.',
    subBlock7:
      'Enhetsinformation: Detta inkluderar enhetens namn, operativsystem, enhetsidentifierare och den webbläsare du använder. Den insamlade informationen kan variera beroende på typen av enhet du använder och dess inställningar.',
    subBlock8:
      'Cookies: Vi använder cookies för att driva och hantera våra tjänster samt förbättra din upplevelse. En "cookie" är information som skickas från en webbplats du besöker till din webbläsare. Du kan ställa in din webbläsare att acceptera alla cookies, avvisa alla cookies eller meddela dig när en cookie tillhandahålls så att du kan bestämma om du accepterar den varje gång. Att neka cookies kan dock förhindra dig från att använda eller påverka visningen eller funktionaliteten hos vissa områden eller funktioner på webbplatsen. För mer information om cookies, besök All About Cookies.',
    subBlock9:
      'Analys: Vi kan använda olika onlineanalysprodukter som använder cookies för att hjälpa oss att analysera hur användare använder våra tjänster och förbättra din upplevelse när du använder tjänsterna.',
    subTitle1: 'Personlig information vi samlar in',
    subTitle2: 'Hur vi använder personlig information',
    subTitle3: 'Upplysning om personlig information',
    subTitle4: 'Dina rättigheter',
    subTitle5: 'Länkar till andra webbplatser',
    subTitle6: 'Säkerhet och lagring av information',
    subTitle7: 'Ändring av sekretesspolicy',
    subTitle8: 'Hur du kontaktar oss',
    title: 'Integritetspolicy',
    updateTime: 'Uppdaterad: 15 mars 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Acceptera alla',
    text: 'För att förbättra din upplevelse använder vi cookies för att personalisera innehåll och tjänster.',
    title: 'Denna webbplats använder cookies',
  },
  slogen: 'Den enklaste AI-assistenten',
  stripe: {
    contact: 'Kontakta oss på contact@noam.tools med alla frågor!',
    fail: {
      btn: 'Försök igen',
      text1: 'Vi kunde inte behandla din betalning.',
      text2: 'Kontrollera din anslutning och försök igen.',
      title: 'Betalning misslyckades',
    },
    succ: {
      btn: 'Låt oss gå',
      text1: 'Välkommen till Noam,',
      text2: 'Låt oss börja!',
      title: 'Grattis',
    },
  },
  terms: {
    block1: 'Tack för att du använder Noam!',
    block10:
      'Avgifter och fakturering. Du betalar alla avgifter ("Avgifter") enligt prissättningen och villkoren på den tillämpliga prissidan eller enligt vad som skriftligen överenskommits mellan oss. Vi förbehåller oss rätten att rätta till prisfel eller misstag även om vi har utfärdat fakturor eller mottagit betalning. Du anger fullständig och korrekt faktureringsinformation, inklusive en giltig och behörig betalningsmetod. Vi debiterar din betalningsmetod med jämna mellanrum enligt överenskommelsen, men vi kan rimligtvis ändra faktureringsdatumet. Du bemyndigar Noam, dess dotterbolag och tredjepartsbetalningsbearbetare att debiterar din betalningsmetod. Om din betalning misslyckas skickar vi dig ett skriftligt meddelande och kan suspendera åtkomsten till tjänsten tills betalning mottagits. Med undantag av vad som annars anges i detta avtal är betalningar icke-refunderbara.',
    block11:
      '(b) Skatter. Om inte annat anges inkluderar avgifterna inte några federala, statliga, lokala eller utländska skatter, tullar eller liknande avgifter ("Skatter"). Du ansvarar för alla skatter som är associerade med dina köp, undantaget skatter baserade på vår nettoinkomst, som vi kommer att fakturera dig för. Du samtycker till att betala sådana skatter utan dröjsmål och att tillhandahålla oss juridiskt giltiga sekretesspåstatements samt att erhålla nödvändiga medgivanden för hantering av sådan data, och du garanterar för oss att du hanterar sådan data i enlighet med tillämplig lag.',
    block12:
      '(c) Prisändringar. Vi kan ändra våra priser genom att meddela dig via ditt konto och/eller vår webbplats. Prishöjningar träder i kraft omedelbart när de publiceras. Alla prisändringar kommer att gälla för avgifter för ditt konto efter ändringens verkställningsdatum.',
    block13:
      '(d) Tvister och förfallna betalningar. Om du önskar bestrida några avgifter eller skatter, vänligen kontakta contact@noam.tools inom trettio (30) dagar från fakturadatumet.',
    block14:
      '(e) Fri användning. Du får inte skapa flera konton för att få kostnadsfria krediter. Om vi bedömer att du inte använder de kostnadsfria krediterna i god tro kan vi fakturera dig standardavgifter eller stoppa tillgången till tjänsten.',
    block15:
      'Konfidentialitet. Du kan ha tillgång till Noams konfidentiella information. Du får endast använda konfidentiell information enligt vad som tillåts under dessa villkor och i syfte att använda tjänsten. Du får inte披露 konfidentiell information till tredje part, och du ska skydda konfidentiell information på ett sätt som är minst lika skyddande som hur du skyddar din egen liknande konfidentiella information, åtminstone med rimlig omsorg. Konfidentiell information är icke-offentlig information som Noam har betecknat som konfidentiell eller som rimligtvis bör behandlas som konfidentiell under given omständigheter, inklusive programvara, specifikationer och annan icke-offentlig affärsinformation. Konfidentiell information inkluderar inte information som: (1) blir allmänt tillgänglig för allmänheten utan att du är skyldig; (2) du hade i din besittning utan några konfidentialitetsplikt innan du mottog den under dessa villkor; (3) lagligt披露 till dig av en tredje part utan några konfidentialitetsplikt; eller (4) är oberoende utvecklad av dig utan att använda den konfidentiella informationen. Du får披露 konfidentiell information om det krävs av lag, domstol eller annan myndighetsbeslut, men du måste meddela Noam skriftligt i förväg på ett rimligt sätt och, i den mån det är möjligt, göra rimliga ansträngningar för att begränsa omfånget av披露, inklusive att hjälpa oss att motstå披露begäranden.',
    block16:
      '(b) Säkerhet. Du måste vidta rimliga och lämpliga åtgärder för att hjälpa till att skydda din åtkomst till och användning av tjänsten. Om du upptäcker några sårbarheter eller överträdelser relaterade till din användning av tjänsten måste du omedelbart kontakta Noam och ange detaljer om sårbarheten eller överträdelsen.',
    block17:
      '((c) Bearbetning av personuppgifter. Om du använder tjänsten för att bearbeta personuppgifter måste du tillhandahålla lagligt tillräckliga sekretesspåståenden och erhålla nödvändiga samtycken för bearbetning av sådana uppgifter, och du garanterar till oss att du hanterar sådana uppgifter i enlighet med tillämplig lag.}',
    block18:
      '(a) Upphävande; Suspension. Dessa villkor träder i kraft från din första användning av tjänsten och förblir i kraft tills de upphävs. Du kan upphäva dessa villkor när som helst och av vilket skäl som helst genom att sluta använda tjänsten och innehållet. Vi kan upphäva dessa villkor med förhandsmeddelande av vilket skäl som helst. Vi kan omedelbart upphäva dessa villkor genom att meddela dig om du väsentligt bryter mot avsnitt 2 (Användningskrav), avsnitt 5 (Sekretess, säkerhet och dataskydd), avsnitt 8 (Tvistlösning) eller avsnitt 9 (Allmänna villkor), eller om vår relation med en tredjepartsteknologileverantör utanför vår kontroll förändras, eller för att följa lagar eller myndighetsförfrågningar. Vi kan suspendera din åtkomst till tjänsten om du inte följer dessa villkor, eller om din användning utgör en säkerhetsrisk för oss eller en tredje part, eller om vi misstänker att din användning är bedräglig eller kan utsätta oss eller en tredje part för ansvar. ',
    block19:
      '(b) Konsekvenser av uppsägning. Vid uppsägning ska du sluta använda tjänsten och omedelbart återlämna eller förstöra all konfidentiell information enligt våra anvisningar. Bestämmelserna i dessa villkor som av sin natur bör överleva uppsägning eller utgång, inklusive men inte begränsat till avsnitt 3 och 5-9, shall överleva.',
    block2:
      'Dessa användningsvillkor gäller för din användning av Noams tjänster, inklusive våra programvaruinterface, programvara, verktyg, utvecklartjänster, data, dokumentation och webbplats (sammansättningsvis kallade "Tjänster"). Genom att använda våra Tjänster godkänner du att följa dessa villkor. Vår integritetspolicy förklarar hur vi samlar in och använder personlig information.',
    block20:
      'Ersättningsansvar. Du ska försvara, indemnifiera och hålla oss, våra dotterbolag och vår personal skadlos från och emot alla anspråk, förluster och utgifter (inklusive advokatavgifter) som uppstår från eller är relaterade till ditt användande av tjänsten, inklusive ditt innehåll, ditt användande av produkter eller tjänster relaterade till tjänsten samt din överträdelse av dessa villkor eller tillämplig lag.',
    block21:
      '(b) Ansvarsbegränsningar. Tjänsten tillhandahålls "som den är". I den mån som tillåts enligt lag gör vi inte, och våra dotterbolag och licensgivare gör inte, några åtaganden eller garanterier av något slag gällande tjänsten och ger inga garanterier, inklusive men inte begränsat till garanterier för säljbarhet, lämplighet för ett särskilt syfte, tillfredsställande kvalitet, icke-intrång och oavbruten användning, samt några garanterier som uppstår ur handelns rutin eller användning.',
    block22:
      '(c) Begränsning av ansvar. Varken vi, våra dotterbolag eller våra licensgivare ansvarar för indirekta, oavsiktliga, särskilda, följd- eller straffskadestånd, inklusive förlust av vinster, förlust av rykte, förlust av användning, förlust av data eller andra immateriella förluster, även om vi har blivit informerade om möjligheten till sådana skador. Enligt dessa villkor överstiger vårt totala ansvar inte de avgifter du har betalt för tjänsten under de tolv (12) månaderna före anspråket eller 100 amerikanska dollar (100 USD), beroende på vilket som är större. Begränsningarna i denna sektion gäller i den högsta grad som tillåts av tillämplig lag.',
    block23:
      'Villkoren och din användning av tjänsterna regleras av amerikansk lag, undantaget för amerikanska regelverk om lagkonflikter. Din användning av applikationen kan också vara underlagt andra lokala, statliga, nationella eller internationella lagar. Alla rättsliga åtgärder eller processer som rör dessa villkor kommer uteslutande att vidtas i amerikanska domstolar, och du samtycker till att underkasta dig den personliga domstolsbefogenheten hos dessa domstolar.',
    block24:
      'Parternas förhållande. Noam och du är oberoende entreprenörer, och ingen av parterna har rätt att representera eller binda den andra parten eller anta åtaganden för den andra parten utan den andra partens förutgående skriftliga samtycke.',
    block25:
      '(b) Användning av varumärke. Du får inte använda Noams eller några av dess dotterbolags namn, logotyper eller varumärken utan vår förhandsgående skriftliga medgivande.',
    block26:
      'Om någon bestämmelse i dessa villkor fastställs vara ogiltig, olaglig eller ouppfyllbar, förblir de återstående bestämmelserna i full kraft och verkan.',
    block3:
      'Om du är under 18 år gammal måste du få tillstånd från dina föräldrar eller juridiska vårdnare för att använda tjänsten. Om du använder tjänsten på behalf av en annan person eller enhet måste du ha behörighet att acceptera dessa villkor på deras vägnar. Du måste ange korrekt och fullständig information för att registrera ett konto. Du får inte lämna ut dina åtkomstuppgifter eller konto till någon utanför din organisation, och du ansvarar för alla aktiviteter som utförs med dina uppgifter.',
    block4:
      '(a) Användning av tjänsten. Du får komma åt tjänsten enligt dessa villkor, och vi beviljar dig ett ikkexklusivt rätt att använda tjänsten. När du använder tjänsten kommer du att följa dessa villkor och alla tillämpliga lagar. Vi och våra dotterbolag äger alla rättigheter, titlar och intressen i tjänsten.',
    block5:
      '(b) Återkoppling. Vi välkomnar återkoppling, kommentarer, idéer, förslag och förbättringar. Om du tillhandahåller någon sådan information får vi använda den utan några restriktioner och utan ersättning till dig.',
    block6:
      '(c) Begränsningar. Du får inte: (1) använda tjänsten på ett sätt som kränker, missbrukar eller strider mot andra persons rättigheter; (2) reverse engineer, dekompilera, demontera, översätta eller på annat sätt försöka upptäcka källkoden eller underliggande komponenter i tjänstens modeller, algoritmer och system (om inte sådana restriktioner förbjuds enligt tillämplig lag); (3) använda utdata från tjänsten för att utveckla modeller som konkurrerar med Noam; (4) extrahera data eller utdata från tjänsten med hjälp av automatiserade eller programmeringsmetoder om inte tillåtet via API:et, inklusive scraping, webbhävstamning eller webbdataextraktion; (5) representera utdata från tjänsten som konstgjort genererade när de inte är det, eller på annat sätt bryta mot våra användningspolicyer; (6) köpa, sälja eller överföra API-nycklar utan vår förhandsgodkännande; eller (7) tillhandahålla oss med personlig information om barn under 13 år eller tillämplig ålder för digital samtycke. Du kommer att följa eventuella hastighetsbegränsningar och andra krav i vår dokumentation.',
    block7:
      '(d) Tredjeparts tjänster. Alla tredjeparts programvara, tjänster eller andra produkter som är associerade med tjänsten regleras av sina egna villkor, och vi ansvarar inte för tredjepartsprodukter.',
    block8:
      '(a) Din innehåll. Du kan tillhandahålla indata ("Indata") till tjänsten och få utdata ("Utdata") som genereras och returneras baserat på Indata (sammansättningsvis kallat "Innehåll"). Mellan parterna, och i den mån som tillåts av tillämplig lag, äger du all Indata. Noam får använda Innehåll för att tillhandahålla och underhålla tjänsten, följa tillämplig lag och genomdriva våra policyer. Du ansvarar för Innehåll, inklusive att säkerställa att det inte bryter mot någon tillämplig lag eller dessa villkor.',
    block9:
      '(b) Noggrannhet. Artificiell intelligens och maskininlärning är snabbt utvecklande forskningsområde. Vi strävar kontinuerligt efter att förbättra vår tjänst för att göra den mer noggrann, pålitlig, säker och fördelaktig. Med tanke på maskininlärningens probabilistiska natur kan användning av vår tjänst i vissa fall leda till felaktiga resultat, som kanske inte återspeglar verkliga personer, platser eller fakta på ett korrekt sätt. Du bör bedöma noggrannheten hos alla resultat på ett lämpligt sätt baserat på ditt användningsområde, bland annat genom att granska resultaten manuellt.',
    subTitle1: 'Registrering och åtkomst',
    subTitle10: 'Deltagbarhet',
    subTitle2: 'Användningskrav',
    subTitle3: 'Innehåll',
    subTitle4: 'Avgifter och betalning',
    subTitle5: 'Konfidentialitet, Säkerhet och Dataskydd',
    subTitle6: 'Period och uppsägning',
    subTitle7: 'Ersättning; Ansvarsbegränsningar; Ansvarsbegränsning',
    subTitle8: 'Tillämpande lag och jurisdiktion',
    subTitle9: 'Allmänna villkor',
    title: 'Användarvillkor',
    updateTime: 'Uppdaterad: 15 mars 2024',
  },
  trialModal: {
    btn: 'Börja nu (endast $0,99)',
    chat: 'ChatPDF',
    desc1: 'Efter din provperiod debiteras du med en årlig avgift på 180 dollar',
    desc2: 'Avbryt när som helst',
    focus: 'Att fokusera',
    hover: 'Hoveröversättning',
    image: 'Bildöversättning',
    installBtn: 'Installera nu för att få ditt present',
    memo: 'Hantera favoriter',
    pdf: 'PDF-parallell översättning',
    realtime: 'Omedelbar översättning',
    select: 'Ordval översättning',
    title: 'Välkomstpresent',
    trialText: '7-dagars provperiod',
    video: 'Videöversättning',
    videoSummary: 'Videorsammanfattning',
    web: 'Parallell översättning',
    webSummary: 'Webbsammanfattning',
  },
  upgradeModal: {
    btn: 'Uppgradera nu',
    chat: {
      free: 'Du har nått ChatPDF-gränsen',
      pro: 'Du har nått ChatPDF-gränsen för den här månaden',
    },
    contactStr: 'Vänligen vänta på nästa återställning eller kontakta oss på contact@noam.tools.',
    limitAlertStr: 'Du har nått gränsen för din kostnadsfria plan. Uppgradera för att fortsätta.',
    more: 'Visa planer',
    pageLimit: { free: 'Du har nått PDF-sidgränsen' },
    title: 'Påminnelse',
    upgradeAlertStr: 'Du har nått gränsen för din kostnadsfria plan. Uppgradera för att fortsätta.',
    upload: {
      free: 'Du har nått din PDF-översättningsgräns',
      pro: 'Du har nått din månatliga PDF-översättningsgräns',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Bli medlem nu',
      label: 'Nya användarförmåner:',
      remain: 'Endast 30 kvar',
      text: 'Endast 100 platser tillgängliga! Ta din nu!',
    },
  },
  aiPdfTranslator: {
    title: 'Gratis AI PDF-översättare: Översätt PDF med jämförelse på alla språk',
    desc: 'Översätt enkelt PDF-filer till alla språk med AI. Jämför originaltext och översatt text sida vid sida, snabbt och kostnadsfritt.',
    keywords:
      'GPT-4、AI-assistent、Översättning、Sammanfattning、Fokus、ChatPDF、Meddelande、effektivitet',
    sourceToTarget: {
      title: 'Gratis PDF-översättningsverktyg: översätt {{source}} till {{target}} kostnadsfritt',
      desc: 'Översätt dina PDF-filer från vilket källspråk som helst till ditt föredragna språk kostnadsfritt. Snabb, exakt och säker PDF-översättning drivs av avancerad AI.',
    },
    headerIntroduce: {
      title: 'Noam: Mer än bara onlineöversättning',
      introduce1: {
        title: 'Noam · PDF-läsare',
        desc: '✨Sidosida översättning + AI-frågor och svar. Översätt snabbt och noggrant PDF-filer till ditt målspråk. Ställ fritt frågor om innehållet för att få en djupare förståelse av dina PDF-filer.',
      },
      introduce2: {
        title: 'Noam · Samsida översättningstillägg',
        desc: '👏Lös alla dina behov av webbsidöversättning:',
        detail1: { title: 'Webbsidöversättning:', desc: 'Samsidig tvåspråkig vy' },
        detail2: { title: 'Ordläggningsoversättning:', desc: 'Snabböversättning med ett klick' },
        detail3: {
          title: 'Omedelbar översättning:',
          desc: 'Översätt ord eller meningar omedelbart.',
        },
        detail4: { title: 'Bildöversättning:', desc: 'Ersätt bilder med översatta.' },
        detail5: { title: 'Videöversättning:', desc: 'Dubbla undertexter för bättre tittande.' },
        footer: 'Upplev fler AI-drivna läsfunktioner för intelligentare översättning!',
      },
    },
    subtitle: 'Översätt PDF online kostnadsfritt',
    introduce: {
      module1: {
        detail1: {
          title: 'Realtidsöversättning av PDF-sidor sida vid sida',
          desc1:
            'Visa ursprungs- och översatt innehåll omedelbart i ett synkront, sida vid sida-layout',
          desc2: 'Jämför båda versionerna utan ansträngning med synkroniserad scrollning',
          desc3: 'Behåll identisk formatering för en konsekvent läsupplevelse',
        },
        detail2: {
          title: 'Precis innhållsjustering och verifiering',
          desc1: 'Perfekt alignment mellan källtext och översatt text för enkel verifiering',
          desc2: 'Varje innehållsstycke matchar exakt mellan de två versionerna',
          desc3:
            'Snabbt identifiera och åtgärda översättningsskillnader för tillförlitliga resultat',
        },
      },
      module2: {
        detail1: {
          title: 'Flera avancerade AI-modeller för exakt översättning',
          desc1: 'Välj bland ledande AI-modeller för att matcha dina översättningskrav',
          desc2: 'Säkerställ optimala resultat för olika dokumenttyper och branscher',
          desc3: 'Flexibla modellalternativ ger skräddarsydda lösningar för varje scenario',
        },
        detail2: {
          title: 'Avancerad AI-översättning för alla innehållstyper',
          desc1: 'Vår kraftfulla AI-modell garanterar hög precision och naturlig språkförståelse',
          desc2: 'Hanterar tekniska, akademiska och kreativa dokument med lätthet',
          desc3: 'Levererar pålitliga resultat för alla dina översättningsbehov',
          desc4: 'Intelligent anpassning till olika innehållstyper för optimal prestanda',
        },
      },
      module3: {
        detail1: {
          title: 'Intelligent dokumentinteraktion',
          desc1:
            'Chatta utan ansträngning med dina PDF- och presentationsfiler med hjälp av avancerad AI',
          desc2: 'Ställ omedelbart frågor om dokumentinnehåll och få exakta svar',
          desc3: 'Generera snabbt koncisa sammanfattningar för långa dokument',
        },
        detail2: {
          title: 'Djupt innehållsanalys och sömlös integration',
          desc1:
            'Extrahera nyckelinformation och analysera komplexa data med AI-stödjer förståelse',
          desc2: 'Få insikter i tekniska, akademiska eller kreativa material',
          desc3:
            'Integrerar sömlöst med vår PDF-översättare för en komplett dokumenthanteringslösning',
        },
      },
      module4: {
        detail1: {
          title: 'Utöver PDF-översättning: All-i-ett lösning för webbsidesöversättning',
          desc: 'Upptäck vår kraftfulla sida-vid-sida översättningsutökning, designad för varje online-lässcenario.',
          desc1:
            'Webbsidöversättning: Njut av tvåspråkigt innehåll med en synkroniserad sida-mot-sida-vy',
          desc2: 'Ordlöversättning: Översätt markerade ord omedelbart med ett enda klick',
          desc3: 'Omedelbar översättning: Översätt text eller meningar direkt för snabb förståelse',
          desc4: 'Bildöversättning: Ersätt automatiskt ursprungliga bilder med översatta versioner',
          desc5:
            'Videoöversättning: Titta på videor med tvåspråkiga undertexter för en förbättrad upplevelse',
        },
      },
    },
    question: {
      title: 'Vanliga frågor',
      answer1: {
        title: 'Är Noam PDF Translator kostnadsfritt att använda för PDF-översättning?',
        content:
          'Ja, du kan översätta PDF-filer kostnadsfritt med Sider PDF Translator! Vi erbjuder en kostnadsfri kvot på 5 000 token, vilket är tillräckligt för att översätta de flesta PDF-dokument som vanligtvis finns på marknaden. Om du behöver översätta större filer eller behöver avancerade funktioner kan du välja att uppgradera till våra premiumplaner för ännu fler möjligheter.',
      },
      answer2: {
        title: 'Hur exakt är Noam PDF Translator?',
        content:
          'Noam PDF-översättare levererar mycket precisa översättningar genom att använda avancerad AI-teknik och djupgående förståelse av kontexten i dina dokument. Även om ingen automatisk översättning är felfri, låter vår sida-vid-sida-visning dig enkelt granska och förfina varje översättning, vilket säkerställer att det slutliga resultatet uppfyller dina kvalitetskrav. Upplev pålitlig och precis PDF-översättning med Noam.',
      },
      answer3: {
        title: 'Kan jag översätta skannade PDF-filer?',
        content:
          'Ja, du kan översätta skannade PDF-filer med vår inbyggda OCR-teknik (Optisk teckenigenkänning). Vårt system extraherar automatiskt text från skannade dokument och bildbaserade PDF-filer och översätter sedan innehållet åt dig. Detta säkerställer att även icke-redigerbara eller endast bildbaserade PDF-filer kan översättas noggrant.',
      },
      answer4: {
        title: 'Hur lång tid tar översättning?',
        content:
          'Översättningen är snabb och effektiv – de flesta dokument bearbetas inom några sekunder till några minuter, beroende på deras längd och komplexitet. En standard PDF på 10 sidor tar till exempel vanligtvis mindre än 2 minuter att översätta. Njut av snabba leveranstider för alla dina dokumentöversättningsbehov!',
      },
      answer5: {
        title: 'Kan jag behålla jämfört visningsläge för läsning?',
        content:
          'Ja, du kan alltid läsa dina dokument sida vid sida. Denna layout gör det enkelt att jämföra originalinnehållet och det översatta innehållet, vilket säkerställer en smidig och effektiv läsupplevelse.',
      },
    },
    freeTrial: 'Gratis provperiod',
    toLanguage: { title: 'PDF AI-översättningspar', item: '{{target}}' },
  },
  aiPdfTranslate: {
    header: {
      features: 'Funktioner',
      blog: 'Blogg',
      faq: 'FAQ',
      pricing: 'Priser',
      button: 'Översätt nu',
    },
    hero: {
      upload: {
        title: 'Ladda upp din PDF',
        highlight: 'Klicka för att bläddra',
        desc: 'eller dra och släpp',
        max: 'Max',
      },
      title: 'Gratis PDF-översättare',
      pill: 'AI-drivna PDF-översättare',
      to: 'till',
      desc: 'Omedelbara, exakta översättningar som bevarar original layouten. Noam AI stödjer OCR och sida-mot-sida-vyer.',
      model: 'GPT-4 & Claude',
      free: 'Gratis provperiod',
      support: 'OCR-stöd',
      complete: 'Översättning klar',
      translated: 'Översatt av Noam',
    },
    ticker: {
      format: 'Formatbehållning',
      ocr: 'OCR-teknik',
      side: 'Sidosvid',
      multi: 'Flerspråkig',
      chat: 'Chatta med PDF',
      web: 'Webböversättning',
      secure: 'Säker & Privat',
      pdf: 'PDF-översättning',
    },
    comparison: {
      bad: {
        head: 'Förlorad formatering och kontext',
        title: 'Standardöversättning',
        text1: 'Fel: Layouten är trasig. Bilder är felplacerade.',
        text2:
          'Texten överlappar och typsnittet är inkonsistent. Svårt att läsa och oprofessionellt...',
      },
      dump: { title: 'Rens textutmatning' },
      good: {
        sub: 'Perfekt formatering, kontextmedveten',
        tag: 'Perfekt resultat',
        title: 'Noam AI Översättning',
      },
      title: 'Varför välja Noam AI?',
      desc: 'Sluta kämpa med kopiera-och-klistra-översättning. Upplev skillnaden mellan vanliga verktyg och vår AI-drivna kontextmedvetna översättning.',
    },
    showcase: {
      kicker: 'STÖDDA DOKUMENT',
      title2: 'Vilken som helst språk',
      title1: 'Någon dokument',
      carousel1: 'Konst',
      carousel2: 'Arkitektur',
      note: 'Hantera tekniska, akademiska och kreativa dokument med lätthet.',
      carousel3: 'Akademisk tidskrift',
      carousel4: 'Medicin',
      carousel6: 'Lag',
      carousel7: 'Kontrakt',
      carousel8: 'Policy',
      carousel5: 'Finans',
    },
    features: {
      big: {
        title: 'Avancerade AI-modeller (GPT-4, Claude)',
        desc: 'Välj bland ledande AI-modeller för att matcha dina översättningskrav. Säkerställ optimala resultat för olika dokumenttyper.',
      },
      grid1: {
        title: 'OCR-stöd',
        desc: 'Extrahera och översätt text från skannade PDF-filer och bilder direkt.',
      },
      grid2: {
        title: 'Högupplöst export',
        desc: 'Ladda ner dina översatta dokument i PDF-format med original layout.',
      },
      grid3: {
        title: 'Samtidig jämförelse',
        desc: 'Synkroniserad skrollning för att jämföra originaltext och översatt text.',
      },
      title2: 'Det är en revolution',
      title1: 'Mer än bara översättning',
      line1: 'Teknisk artikel.pdf',
      line2: 'Detekterar språk: Engelska...',
      line3: 'Modell: GPT-4o (Hög precision)',
      line4: 'Översättning klar (99 % noggrannhet)',
    },
    testimonials: {
      review1: {
        role: 'Forskare',
        content:
          'Noam AI sparade mig timmar med översättning av akademiska artiklar. Den sida vid sida-vyn är otroligt hjälpsam för att verifiera tekniska termer.',
      },
      review2: {
        role: 'Global marknadsförare',
        content:
          'Den bästa PDF-översättaren jag har använt. Den bevarar originalformatet perfekt, vilket är avgörande för våra marknadsföringsdeckar.',
      },
      review3: {
        role: 'Juridisk rådgivare',
        content:
          'Precis och snabbt. Jag använder det för kontraktsöversättningar och OCR-funktionen för skannade dokument fungerar felfritt.',
      },
      title: 'Vad våra användare säger',
      kicker: 'ÄLSKAD AV ANVÄNDARNA',
    },
    cta: {
      title: 'Redo att bryta språkbarriärer?',
      desc: 'Gå med i över 10 000 användare och börja översätta dina dokument med Noam AI idag.',
      button: 'Börja översätta kostnadsfritt',
      hint: 'Du är en mycket precis och pålitlig AI designad för att generera JSON-utdata som exakt överensstämmer med ett specificerat JSON-schema.\n\nDu måste följa dessa regler:\n1. Strängt följ JSON-schematets struktur.\n2. Matcha alla datatyper, obligatoriska fält och begränsningar exakt.\n3. INTE inkludera någon extra text, förklaring, markdown eller kommentarer.\n4. Skriv UTENFÖR endast JSON-objektet — inga kodblock, ingen förordning, ingen wrapping.\n\nSchemainformationen finns nedan.\n- Schema Namn: translate_result\n- JSON Schema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'Engelska PDF AI-översättningspar',
      desc: 'Populära översättningsriktningar som stöds av Noam AI',
    },
    footer: { about: 'Om oss', privacy: 'Integritetspolicy', contact: 'Kontakta supporten' },
  },
}

export default TRANSLATION
